import { Text, Tooltip } from '@mantine/core'

const Row = ({
  children,
  value,
  tooltipText,
}: {
  children?: any
  value: any
  tooltipText?: string
}) => {
  return (
    <div className="flex w-full flex-row items-center gap-2 overflow-hidden">
      <div className="w-[40%] flex-shrink-0 overflow-hidden">
        <Tooltip label={tooltipText} withArrow disabled={!tooltipText}>
          <Text size="xs" className="cursor-default truncate text-doubleNickel-gray-500">
            {tooltipText}
          </Text>
        </Tooltip>
      </div>
      <div className="flex min-w-0 flex-1 flex-row items-center justify-end gap-1 overflow-hidden text-xs text-doubleNickel-gray-900">
        {value}
        <>{children}</>
      </div>
    </div>
  )
}

export default Row
